import EmailEditor from "components/SendLetter/EmailEditor/EmailEditor";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setCardContent, setCreateCampaignDialog, setIsFromSelectedStep,
  setSelectedTemplate
} from "services/api/communication";
import { CreateAutomationForm } from "../CreateAutomationForm/CreateAutomationForm";
import { SendEmail } from "../SendEmail/SendEmail";
import { Wrapper } from "./Theme";
export const NewTemplate = ({
  formik,
  onNext,
  onBack,
  activeStep,
  setActiveStep,
  cardContent,
  eventTypes
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsFromSelectedStep(false));
  }, []);
  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <CreateAutomationForm
            formik={formik}
            onNext={onNext}
            onBack={() => dispatch(setCardContent("Create Campaign"))}
            cardContent={cardContent}
            dropDownType={eventTypes}
          />
        );
      case 1:
        return (
          <EmailEditor
            withoutHeader
            dropDownTypes={true}
            setCampaignModal={() => dispatch(setCreateCampaignDialog(false))}
            buttonClassName="button_className"
            prevouis
            prevouisOnClick={onBack}
            onNext={onNext}
            setTemplate={(template) => dispatch(setSelectedTemplate(template))}
          />
        );
      case 2:
        return (
          <SendEmail
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            isMultiple={false}
            setActiveStep={setActiveStep}
            step={0}
          />
        );

      default:
        return;
    }
  };

  return (
    <Wrapper activeStep={activeStep === 0 || activeStep === 2}>
      {renderContent()}
    </Wrapper>
  );
};
